import React from "react";
import { connect } from "react-redux";
import {
    Container,
     Grid,
    Typography, Accordion, AccordionSummary, AppBar ,Toolbar, AccordionDetails, IconButton, CircularProgress
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import {  ArrowDropDown, CloudDownload, AttachFile } from "@mui/icons-material"
import { validateFile, formatDate, authHeader } from "../../_helpers"
import { withTranslation } from 'react-i18next';
import clsx from "clsx";
import { flushSync } from "react-dom";

const { webApiUrl } = window.appConfig;

const styles = theme => ({
    appBar:{ },
    grow: {
        flexGrow: 1
    },
    bold: {
        fontWeight: "bold"
    },
    mainContainer: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0)
        }
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing(5, 0, 6),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(0)
        }
    },
    expansionPanel: {
        width: '100%',
        '& .MuiAccordionSummary-root.Mui-expanded': {
            minHeight: 48,
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '12px 0'
        }
    },
    documentHeading: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.light,
        '& .MuiSvgIcon-root': {
            color: "white"
        }
    },
    expansionPanelDetails: {
        padding: theme.spacing(1, 3)
    },
    button: {
        '&:hover': {
            color: theme.palette.primary.contrastText
        }
    }
});


class Page extends React.Component {
    state = {
        headers: [],
        uploading: false
    };

    componentDidMount() {
        this.UpdateDocuments();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.selected || prevProps.selected.buildingId !== this.props.selected.buildingId) {
            this.UpdateDocuments();
        }
    }

    UpdateDocuments() {
        const { selected } = this.props;
        if (selected) {
            const url = webApiUrl + 'api/home/GetBuildingDocuments/' + encodeURI(selected.buildingId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                    flushSync(()=>{
                        this.setState({ headers: findResponse });
                    })
                });
        }
    }

    uploadDocument = e => {
        const { selected, t } = this.props;
        const files = Array.from(e.target.files);

        if (validateFile({file:files[0]}) === true) {
            flushSync(()=>{this.setState({ uploading: true })})

            const formData = new FormData()

            formData.append('file', files[0])

            const url = webApiUrl + `api/home/UploadDocument/` + encodeURI(selected.buildingId);
            fetch(url, {
                method: 'POST',
                headers: authHeader(),
                body: formData
            })
                .then(res => res.json())
                .then(res => {
                    flushSync(()=>{
                        this.setState({
                        uploading: false
                    })
                    })
                    this.UpdateDocuments();
                })
                .catch(e => {
                    flushSync(()=>{this.setState({ uploading: false });})
                    alert(t('general.api.error'));
                })
        }
    }

    render() {
        const { t, classes, selected, user } = this.props;
        const { headers, uploading } = this.state;
        return (
            (<Container className={classes.mainContainer}>
                <Grid container>
                    <Grid container className={classes.container} size={{xs:12}}>
                        <AppBar position="sticky" color='inherit' className={classes.appBar}>
                            <Toolbar variant="dense">
                                <Typography className={clsx(classes.grow, classes.bold)}>{t('layout.menuitem.documents')}</Typography>
                                <input accept="*" style={{ display: 'none' }} disabled={!selected || user.viewOnly === true} id="icon-button-file" type="file" onChange={this.uploadDocument} />
                                <label htmlFor="icon-button-file" style={{ margin: 0 }}>

                                    {
                                        uploading ?
                                            <CircularProgress color="inherit" size={24} />
                                            :
                                            <IconButton
                                                color="inherit"
                                                aria-label="upload"
                                                component="span"
                                                disabled={!selected}
                                                size="large">
                                                <AttachFile />
                                            </IconButton>
                                    }
                                </label>
                            </Toolbar>
                        </AppBar>
                        <div style={{ width: '100%' }}>
                            {
                                headers.map((header, indexHeader) => (
                                    <Accordion key={indexHeader} className={classes.expansionPanel} defaultExpanded={true}>
                                        <AccordionSummary
                                            expandIcon={<ArrowDropDown />}
                                            aria-controls={'panel-cat-' + indexHeader + '-content'}
                                            id={'panel-cat-' + indexHeader + '-header'} className={classes.documentHeading}
                                        >
                                            <Typography className={classes.bold}>{header.header}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.documentHeaderDetails}>
                                            <Grid container>
                                                {
                                                    header.attachments.map((document, index) => (
                                                        <Grid
                                                            key={index}
                                                            container
                                                            sx={{
                                                                alignItems: "center",
                                                                justifyContent: "flex-end"
                                                            }}
                                                            size={{xs:12}}>
                                                            <Typography className={classes.grow} noWrap>{document.description}</Typography>
                                                            <Grid>
                                                                <Typography>{document.dateTime && formatDate(new Date(document.dateTime))}</Typography>
                                                            </Grid>
                                                            <Grid>
                                                                <IconButton
                                                                    href={webApiUrl + 'api/home/GetAttachment/' + encodeURI(document.id)}
                                                                    download
                                                                    size="large">
                                                                    <CloudDownload />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }
                        </div>
                    </Grid>
                </Grid>
            </Container>)
        );
    }
}

function mapStateToProps(state) {
    const { authentication, buildings } = state;
    const { user } = authentication;
    const { selected } = buildings;
    return {
        user,
        selected
    };
}

const connectedPage = connect(mapStateToProps)(withTranslation()(withStyles(styles)(Page)));
export { connectedPage as DocumentsPage };